import React, { useContext, useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import playIcon from "@public/img/play.svg";
import { DownloadOption } from "@/entry/server/movie";
import { AppContextType, WonmovContext } from "@/context/app-context";
import { getDefaultPlayerUrl } from "@/utils/movies_helper";
import { videoRepo } from "@/repo/video-repo";
import BookmarkButton from "./bookmark";
import ReportsButton from "./reports";

type MediaActionBarProps = {
    movieId: number;
    movieTitle: string;
    isSeries: boolean;
    isBookmarkedDefault: boolean;
};

export default function MediaActionBar({
    movieId,
    movieTitle,
    isSeries,
    isBookmarkedDefault,
}: MediaActionBarProps) {
    const history = useHistory();
    const { isLoggedIn } = useContext<AppContextType>(WonmovContext);
    const [downloadOptions, setDownloadOptions] = useState<DownloadOption[]>([]);

    useEffect(function () {
        var alive = true;

        videoRepo.getDownloadOptions(movieId).then(function (response) {
            if (!alive) {
                return;
            }
            if (response.status && response.data) {
                setDownloadOptions(response.data);
            }
        });

        return function () {
            alive = false;
        };
    }, [movieId]);

    const playerUrl = useMemo(function () {
        return getDefaultPlayerUrl(movieId, isSeries, downloadOptions);
    }, [movieId, isSeries, downloadOptions]);

    const handlePlayClick = function () {
        if (!isLoggedIn) {
            history.push("/auth");
            return;
        }

        if (playerUrl) {
            history.push(playerUrl);
        }
    };

    const handleDownloadClick = function () {
        var downloadBox = document.getElementById("download-box");
        if (downloadBox) {
            downloadBox.scrollIntoView(true);
        }
    };

    var playDisabled = isLoggedIn && !playerUrl;

    return (
        <div className="media-action-bar">
            <button
                type="button"
                className="media-action-bar__btn media-action-bar__btn--play"
                onClick={handlePlayClick}
                disabled={playDisabled}
            >
                <img src={playIcon} alt={"پخش آنلاین " + movieTitle} />
                <span>پخش آنلاین</span>
            </button>

            <button
                type="button"
                className="media-action-bar__btn media-action-bar__btn--download"
                onClick={handleDownloadClick}
            >
                <span>دانلود</span>
            </button>

            <BookmarkButton
                movieId={movieId}
                isBookmarkedDefault={isBookmarkedDefault}
                className="media-action-bar__icon-btn media-action-bar__icon-btn--bookmark"
            />
            <ReportsButton
                movieId={movieId}
                className="media-action-bar__icon-btn media-action-bar__icon-btn--report"
            />
        </div>
    );
}
